module.exports = __webpack_public_path__ + "img/BG1.f6776a11.png";